import React from "react";
import Layout from "../../components/Layout/Layout";
import NotFoundPanel from "../../components/NotFoundPanel/NotFoundPanel"

const NotFound: React.FC = () => {
    return (
        <Layout isNotFound= {true}>
            <NotFoundPanel />
        </Layout>
    )
}

export default NotFound;